import AllAgentsTable from './components/AllAgentsTable';

export default AllAgentsTable;
